import { Clickable } from "@/components/elements/Clickable/Clickable";
import { useVisible } from "@/hooks/useVisible";
import { FCC } from "@/types/common";
import { Box, Popover as MuiPopover, PopoverProps } from "@mui/material";
import { ReactNode, useRef } from "react";

type TPopoverProps = {
  anchor: ReactNode;
} & Omit<PopoverProps, "open" | "anchorEl" | "onClose">;

export const Popover: FCC<TPopoverProps> = ({ children, anchor, anchorOrigin, transformOrigin, ...rest }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { visible, close, open } = useVisible(false);
  return (
    <>
      <Clickable onClick={open} ref={ref}>
        {anchor}
      </Clickable>
      <MuiPopover
        open={visible}
        anchorEl={ref.current}
        onClose={close}
        anchorOrigin={
          anchorOrigin ?? {
            vertical: "bottom",
            horizontal: "right",
          }
        }
        transformOrigin={
          transformOrigin ?? {
            vertical: "top",
            horizontal: "right",
          }
        }
        {...rest}
      >
        {/* Closes the popover whenever an item inside is clicked (e.g. a nav link). */}
        <Box onClick={close}>{children}</Box>
      </MuiPopover>
    </>
  );
};
